import { Button, Table, Input, notification } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import React, { useState, useEffect } from "react";

import axiosInstance from "utilities/axios";
import FinancingModal from "./components/FinancingModal";
import NewFinancingModal from "./components/NewFinancingModal";

const Financing = () => {
  const [financingOptions, setFinancingOptions] = useState([]);
  const [search, setSearch] = useState("");

  const [selectedOption, setSelectedOption] = useState(null);
  const [openDetails, setOpenDetails] = useState(false);

  const [openNew, setOpenNew] = useState(false);

  useEffect(() => {
    axiosInstance
      .get("/financing-options", { params: { search } })
      .then((response) => {
        setFinancingOptions(response.data);
      })
      .catch((error) => {
        notification.error({
          message: "Error",
          description: "Failed to fetch financing options",
        });
      });
  }, [search]);
  const financingOptionNames = [
    ...new Set(financingOptions.map((option) => option.name)),
  ];
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Term Length",
      dataIndex: "term_length",
      key: "term_length",
    },
    {
      title: "Interest Rate",
      dataIndex: "interest_rate",
      key: "interest_rate",
      render: (text, record) => {
        return record.interest_rate !== undefined &&
          record.interest_rate !== null
          ? Number(record.interest_rate).toFixed(2) + "%"
          : "No interest rate available";
      },
    },
    {
      title: "Minimum Down Payment",
      dataIndex: "down_payment",
      key: "down_payment",
      render: (text, record) => {
        return record.down_payment !== undefined && record.down_payment !== null
          ? Number(record.down_payment).toFixed(2) + "%"
          : "No down payment available";
      },
    },
    {
      title: "Start Date",
      dataIndex: "start_date",
      key: "start_date",
    },
    {
      title: "End Date",
      dataIndex: "end_date",
      key: "end_date",
      render: (text, record) =>
        record.end_date ? record.end_date : "No end date",
      filters: [
        { text: "Expired", value: "expired" },
        { text: "Active", value: "active" },
      ],
      defaultFilteredValue: ["active"],
      onFilter: (value, record) => {
        if (value === "expired") {
          return record.end_date < new Date().toISOString();
        } else {
          // return where records are not expired or have no expiration date
          return (
            record.end_date >= new Date().toISOString() || !record.end_date
          );
        }
      },
    },
    {
      title: "Details",
      dataIndex: "",
      key: "x",
      width: 100,
      render: (text, record) => (
        <Button
          onClick={() => {
            setSelectedOption(record);
            setOpenDetails(true);
          }}
        >
          Details
        </Button>
      ),
    },
  ];

  return (
    <>
      <div style={{ padding: "32px" }}>
        <div style={{ display: "flex" }}>
          <Input.Search
            placeholder="Search Product"
            allowClear
            size="large"
            value={search}
            onChange={(event) => {
              setSearch(event.target.value);
            }}
          />
          <Button
            type="primary"
            style={{ marginLeft: "8px" }}
            onClick={() => {
              setOpenNew(true);
            }}
            icon={<PlusOutlined />}
            size="large"
          >
            New Financing Option
          </Button>
        </div>
        <div style={{ marginTop: "16px" }}>
          <Table
            bordered
            dataSource={financingOptions}
            columns={columns}
            rowKey="id"
          />
        </div>
      </div>
      <FinancingModal
        visible={openDetails}
        onClose={() => setOpenDetails(false)}
        option={selectedOption}
        onChange={() => {
          axiosInstance
            .get("/financing-options", { params: { search } })
            .then((response) => {
              setFinancingOptions(response.data);
            })
            .catch((error) => {
              notification.error({
                message: "Error",
                description: "Failed to fetch financing options",
              });
            });

          if (selectedOption) {
            setSelectedOption(
              financingOptions.find(
                (option) => option.id === selectedOption.id,
              ),
            );
          }
        }}
      />
      <NewFinancingModal
        visible={openNew}
        onClose={() => setOpenNew(false)}
        onChange={() => {
          axiosInstance
            .get("/financing-options", { params: { search } })
            .then((response) => {
              setFinancingOptions(response.data);
            })
            .catch((error) => {
              notification.error({
                message: "Error",
                description: "Failed to fetch financing options",
              });
            });

          if (selectedOption) {
            setSelectedOption(
              financingOptions.find(
                (option) => option.id === selectedOption.id,
              ),
            );
          }
        }}
        financingOptionNames={financingOptionNames}
      />
    </>
  );
};

export default Financing;
